/**
 * Explicit common-field transfer helpers used when switching file category
 * across Intranet case-request wizard flows (including duplicated drafts).
 */

export function pickDraftIdentity(source: Record<string, unknown>): {
  draftRequestId: string;
  referenceNo: string;
} {
  return {
    draftRequestId: typeof source.draftRequestId === 'string' ? source.draftRequestId : '',
    referenceNo: typeof source.referenceNo === 'string' ? source.referenceNo : '',
  };
}

export function pickConnectedMatters(value: unknown): '' | 'yes' | 'no' {
  return value === 'yes' || value === 'no' ? value : 'no';
}

/** Common intake fields shared by most intranet wizards (explicit allow-list). */
export function pickSharedCommonSeed(source: Record<string, unknown>): Record<string, unknown> {
  const corporateInstituteId =
    typeof source.corporateInstituteId === 'string'
      ? source.corporateInstituteId
      : typeof source.corporateInstitute === 'string'
        ? source.corporateInstitute
        : '';
  return {
    ...pickDraftIdentity(source),
    description: typeof source.description === 'string' ? source.description : '',
    provinceId: typeof source.provinceId === 'string' ? source.provinceId : '',
    provinceName: typeof source.provinceName === 'string' ? source.provinceName : '',
    districtId: typeof source.districtId === 'string' ? source.districtId : '',
    districtName: typeof source.districtName === 'string' ? source.districtName : '',
    yourReferenceNumber: typeof source.yourReferenceNumber === 'string' ? source.yourReferenceNumber : '',
    otherExternalReferences:
      typeof source.otherExternalReferences === 'string' ? source.otherExternalReferences : '',
    caseNumber: typeof source.caseNumber === 'string' ? source.caseNumber : '',
    hasConnectedMatters: pickConnectedMatters(source.hasConnectedMatters),
    connectedCaseNumber: typeof source.connectedCaseNumber === 'string' ? source.connectedCaseNumber : '',
    connectedAgdFileRef: typeof source.connectedAgdFileRef === 'string' ? source.connectedAgdFileRef : '',
    urgencyLevelId: typeof source.urgencyLevelId === 'string' ? source.urgencyLevelId : '',
    urgencyLevelName: typeof source.urgencyLevelName === 'string' ? source.urgencyLevelName : '',
    deadline: typeof source.deadline === 'string' ? source.deadline : '',
    urgencyJustification:
      typeof source.urgencyJustification === 'string' ? source.urgencyJustification : '',
    deliveryMethodIds: Array.isArray(source.deliveryMethodIds) ? (source.deliveryMethodIds as string[]) : [],
    deliveryMethods: Array.isArray(source.deliveryMethods) ? (source.deliveryMethods as string[]) : [],
    deliveryOther: typeof source.deliveryOther === 'string' ? source.deliveryOther : '',
    instituteType:
      source.instituteType === 'government' || source.instituteType === 'corporation'
        ? source.instituteType
        : 'government',
    corporateInstituteId,
    corporateInstitute: corporateInstituteId,
    corporateInstituteName:
      typeof source.corporateInstituteName === 'string' ? source.corporateInstituteName : '',
    corporateInstituteOther:
      typeof source.corporateInstituteOther === 'string' ? source.corporateInstituteOther : '',
    corporateInstituteContactName:
      typeof source.corporateInstituteContactName === 'string'
        ? source.corporateInstituteContactName
        : '',
    corporateInstitutePrefix:
      typeof source.corporateInstitutePrefix === 'string' ? source.corporateInstitutePrefix : '',
  };
}
